import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { Address } from "@common/eircode/Address";
import { Fragment } from "react";
import { UseFormMethods } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ICustomerDetailsForm } from "./CustomerDetailsForm";

interface IParams {
    formMethods: UseFormMethods<ICustomerDetailsForm>;
    setPostCodeConfirmed(isConfirmed: boolean): void;
}

export const CustomerDetailsBillingAddress = (props: IParams) => {
    const { formMethods, setPostCodeConfirmed } = props;
    const { t } = useTranslation("customerDetails");

    return (
        <Fragment>
            <Grid className="customer-form__title" container justify="center">
                <Grid item md={5} xs={12}>
                    <Typography color="primary" variant="h2">
                        {t("billingAddress")}
                    </Typography>
                </Grid>
            </Grid>
            <Grid className="customer-form-fields" container>
                <Grid item xs={12}>
                    <Address
                        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
                        // @ts-ignore
                        addressForm={formMethods}
                        buttonColor={"primary"}
                        eirCodeLogoColor={"pink"}
                        isEditing
                        isUpdated={false}
                        prefix="billingAddress"
                        setPostCodeConfirmed={setPostCodeConfirmed}
                    />
                </Grid>
                {/* <Tooltip
                    color="secondary"
                    disableFocusListener
                    disableTouchListener
                    placement="top-end"
                    title={t("sameBillingAddressTooltip", { brand: BRAND_NAME })}
                >
                    <HelpIcon />
                </Tooltip> */}
            </Grid>
        </Fragment>
    );
};
